import React, { useState, useEffect, useMemo } from "react";
import BounceTransition from "components/transition/bounce";
import SportsTypeIcon from "components/sportsTypeIcon";
import OpacityTransition from "components/transition/opacity";
import SportsLoader from "components/sportsLoader";
import style from "../style.module.scss";
import MajorSelectedWrapper from "./selected";
import MajorSportsTypeWrapper from "./sportsType";
import MajorTimeSortWrapper from "./timeSort";
import MajorDefaultWrapper from "./default";
import clsx from "clsx";
import useStore from "../../../../hooks/useStore";
import { _SPORTS_TYPE } from "../../../../common/constants/sportsConstants";
import Banner from "../../../../components/banner";

const MajorWrapper = ({
  page,
  loading,
  selectedGameList,
  selectedTab,
  selectedDate,
  selectedGames,
  setSelectedGame,
  scoreRef,
  resetParentFrame,
  viewType,
  sportsView,
  sportsDefaultFinalList,
  sportsTimeViewFinalList,
}) => {
  const [initView, setInitView] = useState(false);
  const [majorSelected, setMajorSelected] = useState([]);
  const [selectedList, setSelectedList] = useState([]);
  const [toggleHeightChange, setToggleHeightChange] = useState(false);
  const [defaultViewAllFinalCount, setDefaultViewAllFinalCount] = useState(0);
  const [defaultViewAllFinalToggle, setDefaultViewAllFinalToggle] =
    useState(true);
  const { bannerStore } = useStore();
  //
  //  useEffect(() => {
  //    bannerStore.getList();
  //  }, [bannerStore]);

  useEffect(() => {
    if (!loading) {
      setSelectedList(selectedGameList);
      setMajorSelected(selectedGames);
      setInitView(true);
      bannerStore.clearActiveMajorView();
      bannerStore.setSportType(_SPORTS_TYPE.MAJOR);
    } else {
      setInitView(false);
    }
  }, [loading, selectedGameList, selectedGames]);

  //  useEffect(() => {
  //    bannerStore.clearActiveMajorView();
  //  }, [bannerStore, selectedTab]);

  useEffect(() => {
    resetParentFrame(scoreRef.current.scrollHeight);
  });

  useEffect(() => {
    if (toggleHeightChange) {
      resetParentFrame(scoreRef.current.scrollHeight);
      setToggleHeightChange(false);
    }
  }, [toggleHeightChange]);

  const toggleEffect = () => {
    setToggleHeightChange(true);
    bannerStore.clearActiveMajorView();
    bannerStore.setActiveMajorView("placeholder");
  };

  const onClickDefaultViewToggle = () => {
    setDefaultViewAllFinalToggle(!defaultViewAllFinalToggle);
    toggleEffect();
  };

  const emptyListText = useMemo(() => {
    if (selectedTab === "ALL") {
      return "주요경기 경기 일정이 없습니다.";
    } else if (selectedTab === "READY") {
      return "대기중인 주요경기 경기가 없습니다.";
    } else if (selectedTab === "PROGRESS") {
      return "진행중인 주요경기 경기가 없습니다.";
    } else if (selectedTab === "FINAL") {
      return "금일 종료 경기가 없습니다.";
    }
  }, [selectedList, selectedTab]);

  const renderViewCheck = useMemo(() => {
    if (viewType === "DEFAULT_VIEW") {
      let count = 0;
      let finalCount = 0;

      if (!!sportsView) {
        for (let [] of sportsView.entries()) {
          count++;
        }
      }

      if (!!sportsDefaultFinalList && selectedTab === "ALL") {
        for (let [] of sportsDefaultFinalList.entries()) {
          finalCount++;
        }
      }

      if (finalCount > 0) {
        setDefaultViewAllFinalCount(finalCount);
      }

      return selectedList.length > 0 || count > 0 || finalCount > 0;
    } else if (viewType === "SPORTS_TYPE_VIEW") {
      const count = Object.keys(sportsView).reduce(
        (acc, cur) => (acc += sportsView[cur].length),
        0
      );

      return selectedList.length > 0 || count > 0;
    } else {
      return (
        selectedList.length > 0 ||
        sportsView.length > 0 ||
        (sportsTimeViewFinalList.length > 0 && selectedTab === "ALL")
      );
    }
  }, [
    selectedList,
    viewType,
    sportsView,
    sportsDefaultFinalList,
    sportsTimeViewFinalList,
    selectedTab,
  ]);

  useEffect(() => {
    bannerStore.clearActiveMajorView();
    if (sportsView.length === 0 || viewType === "SPORTS_TYPE_VIEW") {
      bannerStore.setActiveMajorView("placeholder");
    }
  }, [sportsView, viewType, selectedTab]);

  const renderViewComponent = useMemo(() => {
    if (viewType === "DEFAULT_VIEW") {
      bannerStore.setFlagMajorType(_SPORTS_TYPE.MAJOR);
      return (
        <>
          <MajorDefaultWrapper
            selectedDate={selectedDate}
            sportsView={sportsView}
            majorSelected={majorSelected}
            setSelectedGame={setSelectedGame}
            selectedTab={selectedTab}
            toggleEffect={toggleEffect}
          />
          {selectedTab === "ALL" && defaultViewAllFinalCount > 0 && (
            <>
              <div className={style.final_header}>
                <h3 className={style.tit}>종료경기</h3>
                <button
                  className={clsx(
                    style.btn_view,
                    !defaultViewAllFinalToggle && style.close
                  )}
                  onClick={onClickDefaultViewToggle}
                >
                  닫기
                </button>
              </div>
              {defaultViewAllFinalToggle && (
                <MajorDefaultWrapper
                  selectedDate={selectedDate}
                  sportsView={sportsDefaultFinalList}
                  majorSelected={majorSelected}
                  setSelectedGame={setSelectedGame}
                  selectedTab={"FINAL"}
                  toggleEffect={toggleEffect}
                />
              )}
            </>
          )}
        </>
      );
    } else if (viewType === "SPORTS_TYPE_VIEW") {
      bannerStore.setFlagMajorType(_SPORTS_TYPE.MAJOR);
      return (
        <MajorSportsTypeWrapper
          selectedDate={selectedDate}
          page={page}
          sportsView={sportsView}
          selectedList={selectedList}
          majorSelected={majorSelected}
          setSelectedGame={setSelectedGame}
          toggleEffect={toggleEffect}
        />
      );
    } else {
      bannerStore.setFlagMajorType(_SPORTS_TYPE.MAJOR);
      return (
        <>
          <MajorTimeSortWrapper
            selectedDate={selectedDate}
            page={page}
            sportsView={sportsView}
            majorSelected={majorSelected}
            setSelectedGame={setSelectedGame}
          />
          {sportsTimeViewFinalList.length > 0 && selectedTab === "ALL" && (
            <>
              <div className={style.final_header_time}>
                <h3 className={style.tit}>종료경기</h3>
              </div>
              <MajorTimeSortWrapper
                sportsView={sportsTimeViewFinalList}
                page={page}
                majorSelected={majorSelected}
                setSelectedGame={setSelectedGame}
                isFinal
              />
            </>
          )}
        </>
      );
    }
  }, [
    viewType,
    sportsView,
    majorSelected,
    setSelectedGame,
    selectedTab,
    defaultViewAllFinalToggle,
    defaultViewAllFinalCount,
    sportsDefaultFinalList,
    sportsTimeViewFinalList,
  ]);
  bannerStore.setFlagMajorType(_SPORTS_TYPE.MAJOR);
  return (
    <div className="score_board_wrap">
      {initView ? (
        renderViewCheck ? (
          <>
            {selectedList.length > 0 && (
              <>
                <MajorSelectedWrapper
                  page={page}
                  selectedList={selectedList}
                  majorSelected={majorSelected}
                  setSelectedGame={setSelectedGame}
                  viewType={viewType}
                  toggleEffect={toggleEffect}
                />
              </>
            )}
            {renderViewComponent}
          </>
        ) : (
          <>
            <Banner paddingTop="10px" paddingBottom="0" />
            <div className={style.livescore_empty}>
              <BounceTransition
                loader={!loading}
                duration={200}
                type="bounce_in"
              >
                <SportsTypeIcon sportsType={"MAJOR"} height={40} width={40} />
              </BounceTransition>
              <OpacityTransition loader={!loading} duration={200}>
                <h3>{emptyListText}</h3>
              </OpacityTransition>
              <OpacityTransition loader={!loading} duration={200} delay={100}>
                <h5>
                  지난경기결과나 예정된 경기는 달력을 클릭하시면 편하게 찾아
                  보실 수 있습니다.
                </h5>
              </OpacityTransition>
            </div>
          </>
        )
      ) : (
        <SportsLoader />
      )}
    </div>
  );
};

export default MajorWrapper;
